import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import './Home.css';
import {images} from '../images/images'
import {Loader} from '../Tools/Loader';


export const Home = () => {

	let myTimer;
	let index = 0;
	
	//select the slides via dots
	function currentSlide(e) {
		//parent is the target. Effect via bubbling
	 	if (e.target !== e.currentTarget){
	 		let clickedItem = e.target.id
		  	showSlides(clickedItem);
	 	}
	 	e.stopPropagation();
	}

	// images switch on interval
	function showSlides(n) {
		//initialize the slide rotation back to normal
		clearInterval(myTimer);
		const slides = document.querySelectorAll('.slide')
		const dots = document.querySelectorAll('.dots')
		slides.forEach(slide => slide.classList.remove('active'))
		dots.forEach(dot => dot.classList.remove('active'))
		slides[n].classList.add('active');
		dots[n].classList.add('active');
		slides[n].style.opacity = 1;

		//begin switch interval
		myTimer = setInterval(() => {
			slides[n].style.opacity = 0.1;
			setTimeout(() => {
				slides[n].classList.remove('active');
				dots[n].classList.remove('active');
			}, 600)
			setTimeout(() => {
				n++;
				if (n === slides.length) {
					n = 0;
				}
			}, 600)
			setTimeout(() => {
				slides[n].classList.add('active');
				dots[n].classList.add('active');
			}, 600)
			setTimeout(() => {
				slides[n].style.opacity = 1;
			}, 650)
			
		}, 5000);
	}

	function screenLoader() {
       const fadeEffect =  setInterval(() => { 
         const preloader = document.querySelector('.preloader')
            if (!preloader.style.opacity) {
              preloader.style.opacity = '1'
            } 
            if (preloader.style.opacity > 0) {
              preloader.style.opacity = '-1'
              setTimeout(() => {preloader.style.display = 'none'}, 100)
            } else {
              clearInterval(fadeEffect)
            }
          }, 200)
      }


	//showslide function will start when page mounts and end when page unmounts
	useEffect(() => {
		//Start the interval when the component mounts
		showSlides(index);
		screenLoader()
		// When the React component unmounts, clear the interval... Returning a function is the equivalent to componentwillunmount()
		return () => clearInterval(myTimer);
	})


	return (
		<main className="homeContainer">
		<Loader />
			<Link to='/profile/analogue_attic'>
				<h1>Featured Label:<br />Analogue Attic</h1>
				<div className='darkOverlay' />
				<div className='slidesContainer'>
					<img className='slide' src={images.analogueAttic.cover} alt='Analogue Attic' />
					<img className='slide' src={images.analogueAttic.cover2} alt='Analogue Attic Event' />
					<img className='slide' src={images.analogueAttic.cover3}  alt='Hopkins Creek' />
					<img className='slide' src={images.analogueAttic.cover4} alt='Analogue Attic Album' />
				</div>
			</Link>
			<section className='coverIndex' onClick={currentSlide}>
				<div className='dots' id='0'/>
				<div className='dots' id='1'/>				
				<div className='dots' id='2'/>
				<div className='dots' id='3'/>
			</section>
		</main>

		)
};